import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../../../layouts/common/ButtonFieldLayout';
import { QuestionFieldName } from '../../types';

import s from './QuestionIsRequiredField.scss';

interface Props {}

const QuestionIsRequiredField: React.FC<Props> = () => {
  const id = useId();
  const { t } = useTranslation();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: QuestionFieldName.IS_REQUIRED, control });

  return (
    <ButtonFieldLayout
      label={t('customExclusivePopup.questionnaire.form.isRequired.label')}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
    >
      <MainToggle
        className={s['toggle']}
        variant="main"
        id={id}
        value={value}
        aria-labelledby={`${id}-label`}
        hasAccessibleLabel
        onChange={onChange}
        size="small"
      />
    </ButtonFieldLayout>
  );
};
QuestionIsRequiredField.displayName = 'QuestionIsRequiredField';

export default QuestionIsRequiredField;
